(function () {
  if (window.__IG_ID18_LOADED__) return;
  window.__IG_ID18_LOADED__ = true;

  var CLASS_NAME = "ig-id18-a";
  var ATTR = "data-ig-id18-payments";
  var SRC =
    "https://cdn.shopify.com/s/files/1/1196/6044/files/Required_set.png?v=1793360791";
  var applying = false;
  var scheduled = null;

  function isActive() {
    return document.documentElement.classList.contains(CLASS_NAME);
  }

  function build() {
    var wrap = document.createElement("div");
    wrap.className = "ig-id18-payments";
    wrap.setAttribute(ATTR, "1");
    wrap.setAttribute("aria-hidden", "true");

    var img = document.createElement("img");
    img.className = "ig-id18-payments__img";
    img.src = SRC;
    img.alt = "";
    img.decoding = "async";
    img.loading = "lazy";
    wrap.appendChild(img);
    return wrap;
  }

  function removeAll() {
    document.querySelectorAll("[" + ATTR + "]").forEach(function (el) {
      el.remove();
    });
  }

  function inject() {
    if (applying) return;
    applying = true;

    try {
      if (!isActive()) {
        removeAll();
        return;
      }

      var targets = document.querySelectorAll(
        ".drawer-footer .cart-checkout-buttons"
      );

      targets.forEach(function (buttons) {
        var footer = buttons.parentElement;
        if (!footer) return;

        var existing = footer.querySelector("[" + ATTR + "]");
        if (existing) {
          if (existing.previousElementSibling === buttons) return;
          existing.remove();
        }

        buttons.insertAdjacentElement("afterend", build());
      });
    } finally {
      applying = false;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      inject();
    });
  }

  function boot() {
    inject();

    var root =
      document.querySelector(".cart-sidebar") ||
      document.querySelector("#cart-drawer") ||
      document.body;

    var obs = new MutationObserver(function (mutations) {
      if (applying) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === "childList" && mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });

    var classObs = new MutationObserver(function () {
      schedule();
    });
    classObs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });

    document.addEventListener("cart:updated", schedule);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
